
export const TmpThemeCustom: any = {
    colors: {
        primary: "red"
    },
    motion: {
        transitionDuration: "0.275s",
        transitionTimingFunction: "cubic-bezier(0.48, 0, 0.48, 1)"
    },
    dropdownButton: {}
}